import { useStyles } from './pesquisa-propaganda-styles';
import { Button, Grid, Fade, useTheme } from '@material-ui/core';
import { useState, useCallback, ChangeEvent, useRef, useEffect, useMemo } from 'react';
import { TextFieldSaurus } from 'views/components/controles/inputs';
import { ProcurarIcon } from 'views/components/icons';
import { useThemeQueries } from 'views';
import { SelectSaurus } from 'views/components/controles/selects/select-saurus/select-saurus';
import { PropagandaListSearchProps } from '../../propaganda-list/propaganda-list-search-props';
import { KeyValueModel } from 'model';
import { PesquisaHeaderProps } from './pesquisa-propaganda-props';

export const PesquisaPropaganda = (props: PesquisaHeaderProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const { isMobile } = useThemeQueries();

    const pesquisaInicial = useMemo(() => {
        return {
            Descricao: '',
            DtInicial: '',
            DtFinal: '',
            Ativo: true,
            Local: -1,
        }
    }, [])

    const [pesquisa, setPesquisa] = useState<PropagandaListSearchProps>(pesquisaInicial);
    const refInput = useRef<HTMLDivElement | null>(null);

    //FOCO AO FICAR VISIVEL
    useEffect(() => {
        if (props.isOpened && !isMobile) refInput.current?.focus();
        else {
            setPesquisa(pesquisaInicial);
        }
    }, [isMobile, pesquisaInicial, props.isOpened]);

    //CHAMADA DO PESQUISAR
    const pesquisar = useCallback(
        (event: any) => {
            event.preventDefault();
            props.onPesquisar(pesquisa);
        },
        [pesquisa, props],
    );

    //ALTERAR A PESQUISA
    const onChangePesquisa = useCallback(
        (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setPesquisa(prev => {
                return {
                    ...prev,
                    [event.target.name]: event.target.value
                }
            });
        },
        [],
    );

    return (
        <Fade in={props.isOpened} mountOnEnter unmountOnExit>
            <form onSubmit={pesquisar}>
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={12} lg={2}>
                        <SelectSaurus
                            name='Ativo'
                            conteudo={[
                                new KeyValueModel(true, 'Ativo'),
                                new KeyValueModel(false, 'Inativo'),
                                new KeyValueModel(-1, 'Todos')
                            ]}
                            fullWidth
                            size='small'
                            label='Situação'
                            value={pesquisa.Ativo}
                            onChange={onChangePesquisa}
                        />
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <TextFieldSaurus
                            name="DtInicial"
                            fullWidth
                            size="small"
                            label="Data Inicial"
                            tipo='DATA'
                            allowSubmit={true}
                            value={pesquisa.DtInicial}
                            placeholder="Data Inicial"
                            onChange={onChangePesquisa}
                            adornmentColor={theme.palette.text.disabled}
                        />
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <TextFieldSaurus
                            name="DtFinal"
                            fullWidth
                            label="Data Final"
                            size="small"
                            tipo='DATA'
                            allowSubmit={true}
                            value={pesquisa.DtFinal}
                            placeholder="Data Final"
                            onChange={onChangePesquisa}
                            adornmentColor={theme.palette.text.disabled}
                        />
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <TextFieldSaurus
                            name="Local"
                            fullWidth
                            label="Local"
                            size="small"
                            tipo='NUMERO'
                            allowSubmit={true}
                            value={pesquisa.Local}
                            onChange={onChangePesquisa}
                            adornmentColor={theme.palette.text.disabled}
                        />
                    </Grid>
                    <Grid item xs={6} lg={4}>
                        <TextFieldSaurus
                            name="Descricao"
                            fullWidth
                            label="Descrição"
                            size="small"
                            allowSubmit={true}
                            tipo="TEXTO"
                            value={pesquisa.Descricao}
                            placeholder="Descrição"
                            onChange={onChangePesquisa}
                            adornmentColor={theme.palette.text.disabled}
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.btnPesquisaContainer}>
                        <Button color='primary' variant='contained' onClick={pesquisar} fullWidth={isMobile}>
                            <ProcurarIcon tipo='BUTTON_PRIMARY' />
                            Pesquisar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Fade>
    );
};